const dialogModal = () => {

	// Doesn't handle opening, otherwise everything else is here
    var dialog = document.querySelector( 'dialog.dialog' );
	if ( ! dialog ) {
		return;
	}

	var closeButton = dialog.querySelector('button[value=close]');
	closeButton.addEventListener('click', function() {
        dialog.close();
    });
}

export { dialogModal };
